var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.66667C0.5 1.95942 0.754613 1.28115 1.20783 0.781049C1.66104 0.280952 2.27573 0 2.91667 0H27.0833C27.7243 0 28.339 0.280952 28.7922 0.781049C29.2454 1.28115 29.5 1.95942 29.5 2.66667C29.5 3.37391 29.2454 4.05219 28.7922 4.55228C28.339 5.05238 27.7243 5.33333 27.0833 5.33333H2.91667C2.27573 5.33333 1.66104 5.05238 1.20783 4.55228C0.754613 4.05219 0.5 3.37391 0.5 2.66667ZM0.5 13.3333C0.5 12.6261 0.754613 11.9478 1.20783 11.4477C1.66104 10.9476 2.27573 10.6667 2.91667 10.6667H27.0833C27.7243 10.6667 28.339 10.9476 28.7922 11.4477C29.2454 11.9478 29.5 12.6261 29.5 13.3333C29.5 14.0406 29.2454 14.7189 28.7922 15.219C28.339 15.719 27.7243 16 27.0833 16H2.91667C2.27573 16 1.66104 15.719 1.20783 15.219C0.754613 14.7189 0.5 14.0406 0.5 13.3333Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqual);
export default __webpack_public_path__ + "static/media/equal.f7000d86da2496625dfbbc7ef633ca99.svg";
export { ForwardRef as ReactComponent };